import BodySharedMinData from "@/mixins/BodySharedMinData";
import GraphRanges from "@/mixins/GraphRanges";
import { Component, Mixins } from "vue-property-decorator";

@Component({})
export default class ChartSummary extends Mixins(
  BodySharedMinData,
  GraphRanges
) {
  minChartHeight = "220px";
  minLegendChartHeight = "220px";
}
